module.exports = __webpack_public_path__ + "static/media/immunology_1.c5722257.JPG";